/** @jsxImportSource @emotion/react */
import { Button, Progress } from "antd";
import ImageNoHistory from "assets/images/profile/icon-no-history.png";
import { ArrowNextIcon } from "constants/config";
import PATH from "constants/path";
import { useAppSelector } from "hooks/app-hook";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { selectDataMemberVip } from "store/member";

import { SideBarProfileStyle } from "./style.index";

const SideBarProfile = () => {
  const { t } = useTranslation(["common", "profile"]);

  const { data: dataMemberVip } = useAppSelector(selectDataMemberVip);
  const navigate = useNavigate();
  return (
    <div css={SideBarProfileStyle.sideBar}>
      <div css={SideBarProfileStyle.sideBarVip.index}>
        <div css={SideBarProfileStyle.sideBarVip.header}>
          {t("profile:current_level")} <span>VIP</span>{" "}
          <span>{dataMemberVip.current_level}</span>
        </div>
        <div css={SideBarProfileStyle.sideBarVip.process}>
          <Progress
            type="circle"
            percent={Number(dataMemberVip.next_level.turnover_percentage)}
          />
        </div>
        <div css={SideBarProfileStyle.sideBarVip.textBox}>
          <div css={SideBarProfileStyle.sideBarVip.title}>
            <div css={SideBarProfileStyle.sideBarVip.dots} />
            <span>{t("profile:deposit_amount")}</span>
          </div>
          {/* <div css={SideBarProfileStyle.sideBarVip.describe}>
            <p>
              {t("profile:remaining_balance")} <span>10.3</span> PESO
            </p>
          </div> */}
        </div>
      </div>
      <div css={SideBarProfileStyle.sideBarRecord.index}>
        <div css={SideBarProfileStyle.sideBarRecord.header}>
          <span>{t("profile:play_record")}</span>
          <ArrowNextIcon />
        </div>
        <div css={SideBarProfileStyle.sideBarRecord.content}>
          <img src={ImageNoHistory} alt={t("profile:no_history_alt")} />
          <div css={SideBarProfileStyle.sideBarRecord.notification}>
            <span>{t("profile:no_games_played")}</span>
          </div>
          <div css={SideBarProfileStyle.sideBarRecord.btn}>
            <Button type="primary" onClick={() => navigate(PATH.home)}>
              {t("profile:go_to_lobby")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBarProfile;
